/**
 * rgpdConsentConfig.js
 * Source unique du texte de consentement du TITULAIRE a la designation
 * d'un beneficiaire (K81).
 *
 * Consomme par :
 *   - OnboardingPage.js (etape beneficiaire)
 *   - AddBeneficiaryPage.js (section 7)
 *   - beneficiaryService.js (calcul du hash pour persistance)
 *
 * REGLE CRITIQUE : le texte affiche a l'utilisateur DOIT etre exactement
 * le meme string que celui hashe cote service. Toute divergence casse la
 * valeur probatoire (hash stocke != hash du texte reellement affiche).
 *
 * Version : incrementer si le wording change. Le hash change automatiquement,
 * les lignes historiques conservent leur preuve v1.
 *
 * Validation avocat T-S5-00 attendue. En cas de modification suggeree par
 * l'avocat : creer v2, ne PAS modifier v1 (immuabilite des preuves).
 */

export const DESIGNATOR_CONSENT_VERSION = 'safeheir-rgpd-designation-v1';

export const DESIGNATOR_CONSENT_TEXT = `Je désigne cette personne comme bénéficiaire dans SafeHeir.

Je comprends que ses données personnelles, notamment son nom, son email et son téléphone, sont enregistrées à cette fin.

En cas de déclenchement du processus de transmission, SafeHeir pourra la contacter dans ce cadre.

Je m'engage à l'informer de sa désignation et à lui transmettre les informations de confidentialité mises à disposition par SafeHeir au titre de l'article 14 du RGPD.`;

/**
 * Calcule le SHA-256 hex du texte de consentement.
 * Utilise TextEncoder (UTF-8, sans BOM) et crypto.subtle.digest — Web Crypto natif.
 *
 * REGLE : ne prend AUCUN argument. Le texte hashe est TOUJOURS DESIGNATOR_CONSENT_TEXT.
 * Passer un texte externe casserait la source unique et donc la garantie
 * texte-affiche == texte-hashe.
 */
export const computeConsentTextHash = async () => {
  const bytes = new TextEncoder().encode(DESIGNATOR_CONSENT_TEXT);
  const hashBuffer = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};
